module.exports = __webpack_public_path__ + "img/moon-0.feb9eb4f.svg";